import React, { useState } from 'react';
import { IconButton } from '@mui/material';
import { ExpandMore, ExpandLess } from '@mui/icons-material';

const ToggleLinkCell = ({ value }) => {
  const [showLink, setShowLink] = useState(false);

  return (
    <div>
      <IconButton onClick={() => setShowLink(!showLink)}>
        {showLink ? <ExpandLess /> : <ExpandMore />}
      </IconButton>
      {showLink && <span className="break-word">{value}</span>}
    </div>
  );
};

export default ToggleLinkCell;
